import React, { useEffect, useMemo, useState } from "react";
import { ViewMeetingProps } from "./view-meeting-props";
import "./view-meeting.scss";
import { formatDate, formatDateTime } from "../../../../../../../utils/utils";
import { getMeetingById } from "../../../../../../../api/campaign";
import { getFullName } from "../common-dialog-task/common-dialog-helper";
import { useSetLoading } from "../../../../../../../common/hooks/appearance";
//import { getMeetingById } from "../../../../../../../api/campaign";
const ViewMeeting: React.FC<ViewMeetingProps> = (props: any) => {
  const { meetingId, customerDetails } = props;
  const [meeting, setMeeting] = useState<any>(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [loading, setLoading] = useState(false);
  const fetchMeetingDetails = async () => {
    setLoading(true);
    try {
      const response = await getMeetingById(
        meetingId,
        customerDetails.id,
        "View Campaigns"
      );
      setMeeting(response?.data?.data);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(
        error?.response?.data?.message ||
        "An error occurred while fetching the lead."
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };
  useEffect(() => {
    if (meetingId && customerDetails?.id) {
      fetchMeetingDetails();
    }
  }, [meetingId, customerDetails]);
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);
  return (
    <div className="lead-view-meeting-view">
      <div className="lead-list-view-details-view-box-full-info">
        <div className="lead-list-view-details-view-box-full-info-data">
          <div className="lead-list-view-details-view-box-full-info-data-section">
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Title
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {meeting?.title || "-"}
              </div>
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                All Day
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {meeting?.all_day || "-"}
              </div>
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                From
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {formatDateTime(meeting?.meetStartTime || "-")}
              </div>
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Participants
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {meeting?.participants?.length > 0
                  ? meeting.participants.map((p: any) => p.email).join(", ")
                  : "-"}
              </div>
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Modified By
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {meeting?.updatedBy
                  ? `${meeting.updatedBy.name}`
                  : "-"}
                <br />
                {formatDateTime(meeting?.updated_at || "-", true)}
              </div>
            </div>
          </div>
          <div className="lead-list-view-details-view-box-full-info-data-section">
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Location
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {meeting?.location || "-"}
              </div>
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Host
              </div>
              {meeting?.host?.name || "-"}
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                To
              </div>
              {formatDateTime(meeting?.meetEndTime || "-")}
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Related To
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {customerDetails ? getFullName(customerDetails.first_name, customerDetails.middle_name, customerDetails.last_name) : "-"}
              </div>
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Reminder
              </div>
              {meeting?.reminder != null
                ? `On ${formatDateTime(meeting.reminder, true)}`
                : "-"}
            </div>
            <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
              <div className="lead-list-view-details-view-box-full-info-data-section-main">
                Created by
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                {meeting?.createdBy
                  ? `${meeting.createdBy.name}`
                  : "-"}
                <br />
                {formatDateTime(meeting?.created_at || "-", true)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="lead-list-view-details-view-box-full-info description-meeting">
        <div className="lead-list-view-details-view-box-full-info-header-text">
          Description
        </div>
        <div className="lead-list-view-details-view-box-full-info-description-box description-box-container">
          {meeting?.description || "-"}
        </div>
      </div>
    </div>
  );
};

export default ViewMeeting;
